/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choice_Checkout_Success_DescriptionInputs */

const fr_plan_choice_checkout_success_description = /** @type {(inputs: Plan_Choice_Checkout_Success_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre formule apparaîtra ici dans quelques instants. Rechargez la page si elle n'apparaît pas.`)
};

/**

* @param {Plan_Choice_Checkout_Success_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_checkout_success_description = /** @type {((inputs?: Plan_Choice_Checkout_Success_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_Checkout_Success_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_checkout_success_description(inputs)
});